import { GetItemEscrowFeesResp } from 'types/api/response/get-item-escrow-fees-resp'

import { api } from './api'

export const getTransactionEscrowFees = ({ transactionId }: { transactionId: number }) =>
  api.get<GetItemEscrowFeesResp>(`/transactions/${transactionId}/escrow_fees`)
